import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { LikeSupporterCommentMutation, LikeSupporterCommentMutationVariables } from './likeComment.graphql';
import { LikeSupporterComment } from './likeComment.graphql';

export type LikeCommentInput = LikeSupporterCommentMutationVariables;

export async function likeComment({ gql: { fetch } }: UtilityContext, { commentId }: LikeCommentInput): Promise<void> {
	const { data } = await fetch<LikeSupporterCommentMutation, LikeSupporterCommentMutationVariables>({
		query: LikeSupporterComment,
		variables: { commentId },
		rejectOnError: true,
	});

	if (!data.likePetitionSupporterComment.success)
		throw new Error(`Unable to like comment (${data.likePetitionSupporterComment.reason || 'unknown'})`);
}
